import { render } from "./badgesone.vue?vue&type=template&id=7fa535d5"
import script from "./badgesone.vue?vue&type=script&lang=js"
export * from "./badgesone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__